import styled, { css } from 'styled-components';
import { GAME_BOX_JACKPOT_TEMPLATE } from '../../../css-constants';
import { Image } from '../../../../raw-components/image/image';

export const commonGameImageCssMixin = css`
  position: absolute;
  width: 100%;

  .${GAME_BOX_JACKPOT_TEMPLATE} & {
    max-width: 20rem;
  }
`;

const DefaultBox = styled(Image)<{hide?: boolean}>`
  opacity: ${({hide}) => hide ? 0: 1};
  ${commonGameImageCssMixin}
  /**
   * BUGFIX-1896215 https://dev.azure.com/888holdings/GamingNDL/_workitems/edit/1896215
   * In a scrolling container (in this case orbit swiper), the first animated icon loaded is above all elements (in this case the static image and the number badge)
   * When swiping, if the first animated icon gets out of the viewport and unloads, the problem is transfered to the second animation.
   * Yes, I know, the solution doesn't have any logic. But I tried this long shot and it worked:
   * https://css-tricks.com/forums/topic/safari-for-ios-z-index-ordering-bug-while-scrolling-a-page-with-a-fixed-element/
   * https://stackoverflow.com/questions/16033416/while-scrolling-on-an-ios-device-the-z-index-of-elements-isnt-working
   * https://stackoverflow.com/questions/9807620/ipad-safari-scrolling-causes-html-elements-to-disappear-and-reappear-with-a-dela
   */
  -webkit-transform: translate3d(0,0,0);
  /**
   * Because YES, Safari is the new Internet Explorer!!!
   */
`;

export const GameImageDefaultBox = DefaultBox;